import moment from "jalali-moment";
moment.locale('fa');
let m = moment();



// let intial_state = m.format('jYYYY/jM/jD');

let intial_state = {
  year: m.jYear(),
  month: m.jMonth()+1,
  day:m.jDate()
}

const CalendarDaySelectedReducer=(state =intial_state, action)=>{
  switch (action.type) {
    case "daySelect":
      return {
        year:action.year,
        month:action.month,
        day:action.day
      }
    default:
      return state;
  }
}

export default CalendarDaySelectedReducer;